const readMetaContent = (selector) => {
  if (typeof document === 'undefined') return '';
  const el = document.querySelector(selector);
  if (!el) return '';
  return String(el.getAttribute('content') || '').trim();
};

const readLinkHref = (selector) => {
  if (typeof document === 'undefined') return '';
  const el = document.querySelector(selector);
  if (!el) return '';
  return String(el.getAttribute('href') || '').trim();
};

export const getShareMeta = () => {
  if (typeof document === 'undefined') {
    return { title: '', description: '', image: '', url: '', domain: '' };
  }

  const ogTitle = readMetaContent('meta[property="og:title"]') || readMetaContent('meta[name="og:title"]');
  const ogDescription = readMetaContent('meta[property="og:description"]') || readMetaContent('meta[name="og:description"]');
  const ogImage = readMetaContent('meta[property="og:image"]') || readMetaContent('meta[name="og:image"]');
  const ogUrl = readMetaContent('meta[property="og:url"]') || readMetaContent('meta[name="og:url"]');
  const twitterTitle = readMetaContent('meta[name="twitter:title"]');
  const twitterDescription = readMetaContent('meta[name="twitter:description"]');
  const twitterImage = readMetaContent('meta[name="twitter:image"]');
  const metaDescription = readMetaContent('meta[name="description"]');
  const canonicalUrl = readLinkHref('link[rel="canonical"]');

  const url = ogUrl || canonicalUrl || (typeof window !== 'undefined' ? window.location.href : '');
  const domain = (() => {
    try {
      return url ? new URL(url).hostname : '';
    } catch (_) {
      return '';
    }
  })();

  return {
    title: ogTitle || twitterTitle || document.title || '',
    description: ogDescription || twitterDescription || metaDescription || '',
    image: ogImage || twitterImage || '',
    url,
    domain
  };
};

export const mergeShareMeta = (pageMeta = {}, shareInfo = {}) => {
  // 单曲分享时优先使用 API 返回的详情页地址（shareInfo.url），否则用当前页
  const url = shareInfo.url || pageMeta.url || '';
  const domain = pageMeta.domain || (() => {
    try {
      return url ? new URL(url).hostname : '';
    } catch (_) {
      return '';
    }
  })();

  return {
    title: pageMeta.title || shareInfo.title || '',
    description: pageMeta.description || shareInfo.description || '',
    image: pageMeta.image || shareInfo.cover || shareInfo.image || '',
    url,
    domain
  };
};

